module.exports = __webpack_public_path__ + "6f4d4f15213096ef0f94f8c5995f092b.pdf";